export const numberWithCommas = (x) => {
  if (x === undefined || x === null) return '';
  x = x.toString();
  var pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(x))
      x = x.replace(pattern, "$1,$2");
  return x;
}